import { api } from '@api'
import { Truck } from '@types'

interface CreateTruckResponse {
  result: Truck
}

const createTruck = async (payload: Truck) => {
  const response = await api.post<CreateTruckResponse>('/trucks', { truck: payload })

  return response.data.result
}

export const TrucksApi = { createTruck }
